export default {
  name: 'Documentos',
  children: [
    {
      name: 'Acordos',
      children: [
        {
          name: 'Compensação de Horas',
          value: 'acordo-comhor',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDescription: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Prorrogação de Horas',
          value: 'acordo-prohorcol',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Declarações',
      children: [
        {
          name: 'Declaração para o Vale Transporte',
          value: 'declaracao-vt',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Declaração para o Vale Alimentação',
          value: 'declaracao-va',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Declaração de Contribuição Sindical',
          value: 'declaracao-contsind',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Declaração de Dependentes para o IRRF',
          value: 'declaracao-ir',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Declaração de Dependentes para o Salário Família',
          value: 'declaracao-sf',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Férias',
      children: [
        {
          name: 'SAP - Solicitação de Pagamento',
          value: 'ferias-sap',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Solicitação de Férias em Abono Pecuniário',
          value: 'ferias-soliabono',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Aviso de Férias',
          value: 'ferias-aviso',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Rescisão de Contrato de Trabalho',
      children: [
        {
          name: 'Aviso de Rescisão',
          value: 'aviso-rescisao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showGroupBy: true,
          },
        },
        {
          name: 'SAP - Solicitação de Pagamento',
          value: 'rescisao-sap',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Etiquetas',
      children: [
        {
          name: 'Etiquetas de Contrato',
          value: 'etiqueta-contrato',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Etiquetas de Férias',
          value: 'etiqueta-ferias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Etiquetas de Aumento Salarial',
          value: 'etiqueta-salario',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'eSocial',
      children: [
        {
          name: 'Recibos de Envio',
          value: 'esocial-protocolo',
          options: {
            showDateMonthPeriod: true,
          },
        },
      ],
    },
    {
      name: 'Ficha de Registro do Colaborador',
      value: 'ficha-registro',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showPartnerEmployeeSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Contrato Admissional',
      value: 'contrato-admi',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Contrato Admissional - Modelo 2',
      value: 'contrato-admi-modelo2',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Aviso de Advertência',
      value: 'aviso-advertencia',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDescription: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Aviso de Suspensão',
      value: 'aviso-suspensao',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Informe de Rendimentos',
      value: 'informe-rendimento',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateYearPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Informe de Rendimentos - Diretores',
      value: 'informe-rendimento-dir',
      options: {
        showDateYearPeriod: true,
      },
    },
    {
      name: 'Recibo de CTPS',
      value: 'recibo-ctps',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Folha de Ponto Individual',
      value: 'cartao-ponto',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Folha de Ponto Indivisual - Estagiários',
      value: 'INTERN_POINT_CARD',
      options: {
        showDateMonthPeriod: true,
      },
    },
    {
      name: 'Termo de Compromisso de Estágio',
      value: 'contrato-estagiario',
      options: {
        showDateMonthPeriod: true,
      },
    },
  ],
};
